import { create } from 'zustand';

interface HandleResetPermission {
    resetPermissions: boolean;
    setResetPermissions: (open: boolean) => void;
}

// Create the Zustand store with types
const ResetPermissions = create<HandleResetPermission>((set) => ({
    resetPermissions: false,
    setResetPermissions: (open: boolean) => set({ resetPermissions: open }),
}));

export default ResetPermissions;
